import { NAME as APP_NAME } from '../constants';

export const NAME = `${APP_NAME}/INVOICES`;

export const REDUCER_NAME = 'invoices';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/finance/credit-terms/invoices`;
export const ROUTES = {
  ROOT: '/finance/invoices',
};

export const INVOICE_STATUS = {
  PAID: 'PAID',
  OPEN: 'OPEN',
};
